// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PageContainer-module__pageContainer___WxbpY{padding:16px 16px}`, "",{"version":3,"sources":["webpack://./src/modules/shared/components/Layouts/PageContainer.module.scss"],"names":[],"mappings":"AAEA,6CAEE,iBAAA","sourcesContent":["@use 'scouting-ui/lib/scss/variables' as vars;\n\n.pageContainer {\n  // Top gap keeps the first element off the navbar\n  padding: vars.$spacing-md vars.$spacing-md;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `PageContainer-module__pageContainer___WxbpY`
};
export default ___CSS_LOADER_EXPORT___;
